<template>
  <el-col
    :lg="8"
    :md="8"
    :sm="12"
    :xs="24"
  >
    <!--      value-format="yyyy-MM-dd HH-mm-ss"-->
    <div class="label">{{$t('account_type')}}</div>
    <el-select
      style="width: 100%"
      v-model="type"
      @change="typeChange"
    >
      <el-option
         v-for="(item,index) in accountTypeList"
         :key="index"
         :label="item.label"
         :value="item.value"
      ></el-option>
    </el-select>
  </el-col>
</template>

<script>
export default {
  name: "centSelect",
  props: {
    tabsType: {
      type: String,
    },
  },
  data() {
    let _this = this;
    return {
      type: _this.tabsType || 'USD',
      accountTypeList: [
        {label: _this.$t('USD_account'),value: 'USD'},
        {label: _this.$t('Cent_Account'),value: 'USC'},
      ]
    }
  },
  methods: {
    typeChange(val) {
      this.$emit('send-type',val);
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .label {
    margin-bottom: 5px;
  }
  .header-sub-item {
    width: 100%;
  }
}
</style>
